import PropTypes from 'prop-types';
import { graphql, useFragment } from 'react-relay';
import { getFilterValues, getAppliedFilter } from '../sbSharedRefineMenuHelpers.ts';

// components
import { SbSharedRefineMenuRadioSelect } from './SbSharedRefineMenuRadioSelect.jsx';
import { SbSharedRefineMenuTypeaheadContainer } from '../SbSharedRefineMenuTypeahead/SbSharedRefineMenuTypeaheadContainer.jsx';

const viewerFragment = graphql`
    fragment SbSharedRefineMenuRadioSelectSearch_viewer on Viewer {
        ...SbSharedRefineMenuTypeaheadContainer_viewer
    }
`;
const itemSearchFragment = graphql`
    fragment SbSharedRefineMenuRadioSelectSearch_itemSearch on ItemSearchQueryConnection {
        displayUriRef
        ...SbSharedRefineMenuTypeaheadContainer_itemSearch
        appliedFilters {
            name
            localizedFilterName
            canBeDismissed
            values {
                urlLabel
                linkReference
                count
                displayName
            }
        }
    }
`;

export const SbSharedRefineMenuRadioSelectSearch = ({
    viewer: viewerRef,
    itemSearch: itemSearchRef,
    values,
    filterName,
    totalCount = 0,
    showSearchBar,
    trackingOptions,
}) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    const { appliedFilters, displayUriRef } = itemSearch;

    const appliedFilter = getAppliedFilter(appliedFilters, filterName);
    const appliedFilterValues = getFilterValues(appliedFilters, filterName);
    const canBeDismissed = appliedFilter ? appliedFilter.canBeDismissed : true;

    return (
        <SbSharedRefineMenuTypeaheadContainer
            viewer={viewer}
            filterName={filterName}
            itemSearch={itemSearch}
            availableFilterValues={values}
            appliedFilterValues={appliedFilterValues}
            showSearchBar={showSearchBar}
            trackingOptions={trackingOptions}
        >
            {({ valuesToShow }) => (
                <SbSharedRefineMenuRadioSelect
                    filterName={filterName}
                    totalCount={totalCount}
                    valuesToShow={valuesToShow}
                    displayUriRef={displayUriRef}
                    canBeDismissed={canBeDismissed}
                    appliedFilterValues={appliedFilterValues}
                    trackingOptions={trackingOptions}
                />
            )}
        </SbSharedRefineMenuTypeaheadContainer>
    );
};

SbSharedRefineMenuRadioSelectSearch.propTypes = {
    totalCount: PropTypes.number,
    values: PropTypes.array.isRequired,
    viewer: PropTypes.object.isRequired,
    filterName: PropTypes.string.isRequired,
    itemSearch: PropTypes.object.isRequired,
    showSearchBar: PropTypes.bool,
    trackingOptions: PropTypes.object,
};
